import React from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography,
} from "@mui/material";

const SOURCE_LABEL = {
    public_current: "Public URL",
    entitled: "Account download",
    assignment: "Customer link",
    admin: "Admin",
    demo: "Demo access",
    grant: "Assigned build",
};

function sourceLabel(source) {
    const raw = String(source || "");
    const [kind, channel] = raw.split(":");
    const base = SOURCE_LABEL[kind] || SOURCE_LABEL[raw] || raw || "—";
    if (!channel) return base;
    if (channel === "updater") return `${base} · updater`;
    if (channel === "setup_alt") return `${base} · alternate`;
    if (channel === "setup") return `${base} · installer`;
    return `${base} · ${channel}`;
}

function formatWhen(value) {
    if (!value) return "—";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return value;
    return date.toLocaleString();
}

function whoLabel(row) {
    if (row.customerName && row.email) return `${row.customerName} · ${row.email}`;
    if (row.customerName) return row.customerName;
    if (row.email) return row.email;
    return "Anonymous";
}

export default function SoftwareDownloadLogDialog({
    open,
    onClose,
    title = "Downloads",
    loading = false,
    total = 0,
    uniqueCount = 0,
    anonymousCount = 0,
    events = [],
}) {
    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                <Stack spacing={1.5} sx={{ pt: 0.5 }}>
                    <Typography variant="body2" color="text.secondary">
                        {total} download{total === 1 ? "" : "s"}
                        {uniqueCount ? ` · ${uniqueCount} identified` : ""}
                        {anonymousCount ? ` · ${anonymousCount} anonymous` : ""}
                    </Typography>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>When</TableCell>
                                <TableCell>Who</TableCell>
                                <TableCell>Source</TableCell>
                                <TableCell>IP</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {loading ? (
                                <TableRow>
                                    <TableCell colSpan={4}>
                                        <Typography color="text.secondary">Loading…</Typography>
                                    </TableCell>
                                </TableRow>
                            ) : events.length === 0 ? (
                                <TableRow>
                                    <TableCell colSpan={4}>
                                        <Typography color="text.secondary">No downloads recorded yet.</Typography>
                                    </TableCell>
                                </TableRow>
                            ) : (
                                events.map((row) => (
                                    <TableRow key={row.id} hover>
                                        <TableCell>{formatWhen(row.createdAt)}</TableCell>
                                        <TableCell>
                                            <Typography variant="body2">{whoLabel(row)}</Typography>
                                            {row.userAgent ? (
                                                <Typography
                                                    variant="caption"
                                                    color="text.secondary"
                                                    display="block"
                                                    noWrap
                                                    sx={{ maxWidth: 320 }}
                                                >
                                                    {row.userAgent}
                                                </Typography>
                                            ) : null}
                                        </TableCell>
                                        <TableCell>{sourceLabel(row.source)}</TableCell>
                                        <TableCell>
                                            <Typography variant="body2" fontFamily="monospace">
                                                {row.ip || "—"}
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                ))
                            )}
                        </TableBody>
                    </Table>
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Close</Button>
            </DialogActions>
        </Dialog>
    );
}
